export const showWarehouse = (state) => state.warehouse
